import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import { Table } from 'reactstrap';
import {ToastContainer, ToastStore} from 'react-toasts';

import AdminListStyles from './AdminList.css';
import PaginationStyles from './components/Pagination.css'

import utilities from './components/Utilities';
let Utilities = new utilities();

class Customers extends Component {

    constructor(props) {

        super(props);

        this.state = {
            activePage: 1,
            totalItems: 1,
            itemsCountPerPage: 20,
            keywords: "",
            customers: [],
        };

    }

    componentDidMount() {
        this.runSearch();
        document.title = window.globalVars.pageTitleBefore + "Customers" + window.globalVars.pageTitleAfter;
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    }

    runSearchReset = () => {
        this.setState({
            activePage: 1
        }, function() {
            this.runSearch();
        }.bind(this))
    }

    runSearch = (page) => {

        window.globalVars.server.api({
            method: "post",
            url: "api/user/all",
            data: {
                activePage: this.state.activePage,
                keywords: this.state.keywords,
            },
            then: function(res) {
                this.afterSearch(res.data.data)
            }.bind(this),
            catch: function(e) {

            }.bind(this)
        })

    }

    afterSearch = (results) => {
        this.setState({
            totalItems: results.totalResults,
            customers: results.results,
        })
    }

    updatePage = (page) => {

        this.setState({
            activePage: page
        }, () => {
            this.runSearch();
        })

    }

    handleChange = (name, value) => {
        let state = this.state;
        state[name] = value;
        this.setState({state});
    }

    render() {

        return (
            <div className="customers-container">
                <div className="customers">
                    <div className="main-container">
                        <h1>Customers</h1>
                        <div className="form-group">
                            <label for="keywords">Keywords</label>
                            <input
                                type="text"
                                placeholder="Keywords"
                                id="keywords"
                                defaultValue={this.state.keywords}
                                onChange={(e) => { this.handleChange("keywords", e.target.value) } }
                            />
                        </div>
                        <button className="search-btn" onClick={() => { this.runSearchReset() } }>Search</button>
                        <div className="table-wrapper">
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Number</th>
                                        <th>Registered</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { (this.state.customers.length === 0) ?
                                        <tr>
                                            <td>No results</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        :
                                        this.state.customers.map(item => {
                                            return (<tr onClick={() => {
                                                document.location = "/admin/customers/" + item._id
                                            }} data-id={item._id}>
                                                <td>{item.firstName + item.lastName}</td>
                                                <td>{item.email}</td>
                                                <td>{item.tel}</td>
                                                <td>{Utilities.formatDate(item.createdAt, "DD/MM/YYYY")}</td>
                                            </tr>)
                                        })
                                    }
                                </tbody>
                            </Table>
                        </div>
                        <div className="pagination-wrapper">
                            <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCountPerPage}
                                totalItemsCount={this.state.totalItems}
                                pageRangeDisplayed={this.state.pageRangeDisplayed}
                                onChange={this.updatePage}
                            />
                        </div>
                    </div>
                </div>
                <ToastContainer store={ToastStore}/>
            </div>
        );

    }

}

export default Customers;



// WEBPACK FOOTER //
// ./src/Customers.js